module.exports = __webpack_public_path__ + "static/media/fitnessxo-logo.3f2b886c.png";